import { render, staticRenderFns } from "./ExportInvoice.vue?vue&type=template&id=980a2310"
import script from "./ExportInvoice.vue?vue&type=script&lang=js"
export * from "./ExportInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports